<template>
  <div>
    <v-menu  v-for="menuItem in model" :key="menuItem.$ID" v-model="menuItem.value" :open-on-hover="true" :offset-y="true">
      <template v-slot:activator="{ on }">
        <v-btn @click="onMenuItemClick(menuItem)" text v-on="on">{{menuItem.Caption}}</v-btn>
      </template>

      <v-list v-if="menuItem.Items">
        <v-list-item @click="onMenuItemClick(item)" v-for="(item, index) in menuItem.Items" :key="index">
          <v-list-item-title>{{ item.Caption }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ['model'],
  methods: {
    onMenuItemClick(item) {
      this.$emit('onMenuItemClick', item)
    }
  }
}
</script>
